import { CommonModule, CurrencyPipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { GaugeModule } from 'angular-gauge';

import { BadgeNotificationsComponent } from '../../../shared/components/badge-notifications/badge-notifications.component';
import { CircleBannerComponent } from '../../../shared/components/circle-banner/circle-banner.component';
import {
    DisclaimerSubjectChangeComponent
} from '../../../shared/components/disclaimer-subject-change/disclaimer-subject-change.component';
import {
    DropdownAutocompleteComponent
} from '../../../shared/components/dropdown-autocomplete/dropdown-autocomplete.component';
import { EmptyDataComponent } from '../../../shared/components/empty-data/empty-data.component';
import { HelpDeliveryComponent } from '../../../shared/components/help-delivery-popover/help-delivery-popover.component';
import { ListMorePopoverComponent } from '../../../shared/components/list-more-popover/list-more-popover.component';
import { PasswordFormatComponent } from '../../../shared/components/password-format/password-format.component';
import { ProductCardComponent } from '../../../shared/components/product-card/product-card.component';
import { PromoPresentComponent } from '../../../shared/components/promo-present/promo-present.component';
import { PromotionsCardComponent } from '../../../shared/components/promotions-card/promotions-card.component';
import { RangeInputComponent } from '../../../shared/components/range-input/range-input.component';
import { SexSelectorComponent } from '../../../shared/components/sex-selector/sex-selector.component';
import { ModuleSharedModule } from '../../../shared/modules/module-shared.module';
import { AssetsUrlPipe } from '../../../shared/pipes/assets-url/assets-url.pipe';
import { CheckIconPipe } from '../../../shared/pipes/check-icon/check-icon.pipe';
import { FilterArrayPipe } from '../../../shared/pipes/filter-array/filter-array.pipe';
import { FiltroPipe } from '../../../shared/pipes/filtro.pipe';
import { HtmlSeguroPipe } from '../../../shared/pipes/html-seguro.pipe';
import { IsNullEmptyPipe } from '../../../shared/pipes/is-null-empty/is-null-empty.pipe';
import { SumTotalPipe } from '../../../shared/pipes/sum-total/sum-total.pipe';
import { TypePromoColorPipe } from '../../../shared/pipes/type-promo-color/type-promo-color.pipe';
import { VideoPipe } from '../../../shared/pipes/video/video.pipe';
import { CardsRoundedComponent } from '../components/cards-rounded/cards-rounded.component';
import { CaritaComponent } from '../components/carita/carita.component';
import { CaritasComponent } from '../components/caritas/caritas.component';
import { ComprasGraphComponent } from '../components/compras-graph/compras-graph.component';
import { IncidenciaEjecucionComponent } from '../components/incidencia-ejecucion/incidencia-ejecucion.component';
import { InputValidatorComponent } from '../components/input-validator/input-validator.component';
import { ModalDetailComponent } from '../components/modal-detail/modal-detail.component';
import { ModalQuestionComponent } from '../components/modal-question/modal-question.component';
import { NoticiasCardsComponent } from '../components/noticias-cards/noticias-cards.component';
import { OrderCartComponent } from '../components/order-cart/order-cart.component';
import { PasswordsValidatorComponent } from '../components/passwords-validator/passwords-validator.component';
import { PreguntaComponent } from '../components/pregunta/pregunta.component';
import { PreguntasComponent } from '../components/preguntas/preguntas.component';
import { PromocionPreviewComponent } from '../components/promocion-preview/promocion-preview.component';
import { PushEjecucionPageModule } from '../components/push-ejecucion/push-ejecucion.module';
import { SliderComponent } from '../components/slider/slider.component';
import { SwitchesComponent } from '../components/switches/switches.component';
import { TextoComponent } from '../components/texto/texto.component';
import { TitleComponent } from '../components/title/title.component';
import { ToolbarFotoExitoComponent } from '../components/toolbar-foto-exito/toolbar-foto-exito.component';
import { TotalProductsComponent } from '../components/total-products/total-products.component';
import { ZoomImagePageModule } from '../components/zoom-image/zoom-image.module';
import { RangeLimitsComponent } from './../../../shared/components/range-limits/range-limits.component';
import { EcoMeasureDirective } from './../../../shared/directives/eco-measure/eco-measure.directive';
import { LimitRangeDirective } from './../../../shared/directives/limit-range.directive';
import { HighlightUnitsPipe } from './../../../shared/pipes/highlight-units/highlight-units.pipe';
import { RemainingTimePipe } from './../../../shared/pipes/remaining-time/remaining-time.pipe';
import { StatusRcppPipe } from './../../../shared/pipes/status-rcpp/status-rcpp.pipe';
import { SummaryPricePipe } from './../../../shared/pipes/summary-price/summary-price.pipe';


const COMPONESTS = [
    TitleComponent
    , BadgeNotificationsComponent
    , SliderComponent
    , NoticiasCardsComponent
    , CardsRoundedComponent
    , CaritaComponent
    , CaritasComponent
    , PreguntaComponent
    , PreguntasComponent
    , TextoComponent
    , TotalProductsComponent
    , OrderCartComponent
    , SwitchesComponent
    , InputValidatorComponent
    , ModalDetailComponent
    , PromocionPreviewComponent
    , ModalQuestionComponent
    , IncidenciaEjecucionComponent
    , ToolbarFotoExitoComponent
    , ComprasGraphComponent
    , DisclaimerSubjectChangeComponent
    , CircleBannerComponent
    , RangeLimitsComponent
]

@NgModule({
    declarations: [
        ...COMPONESTS
    ],
    imports: [
        IonicModule,
        CommonModule,
        TranslateModule,
        GaugeModule.forRoot(),
        ModuleSharedModule,
        FormsModule,
        ReactiveFormsModule,
        ZoomImagePageModule,
        PushEjecucionPageModule,
        NgxChartsModule
    ],
    exports: [
        ...COMPONESTS,
        IonicModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        EmptyDataComponent,
        PasswordFormatComponent,
        PasswordsValidatorComponent,
        DropdownAutocompleteComponent,
        SexSelectorComponent,
        HtmlSeguroPipe,
        AssetsUrlPipe,
        CheckIconPipe,
        LimitRangeDirective,
        EcoMeasureDirective,
        FiltroPipe,
        TypePromoColorPipe,
        SumTotalPipe,
        StatusRcppPipe,
        RemainingTimePipe,
        HighlightUnitsPipe,
        IsNullEmptyPipe,
        FilterArrayPipe,
        CurrencyPipe,
        VideoPipe,
        TranslateModule,
        ListMorePopoverComponent,
        HelpDeliveryComponent,
        ProductCardComponent,
        RangeInputComponent,
        PromotionsCardComponent,
        PromoPresentComponent,
        SummaryPricePipe,
    ],
    providers: [
        FiltroPipe,
        TypePromoColorPipe,
        SumTotalPipe,
        StatusRcppPipe,
        RemainingTimePipe,
        IsNullEmptyPipe,
        FilterArrayPipe,
        CurrencyPipe,
        HighlightUnitsPipe,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
